import * as React from 'react';
import { msalInstance } from '../..';
import { AiOutlineHome } from 'react-icons/ai';
/**
* Sandeep: Unauthorized access page.
*/
class UnauthorizedAccess extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (<>
            <img src={setting.cdnUrl + '/assets/images/logo/logo_trailboss.png'} style={{ maxWidth: '100px' }} />
            <div className="row heightCustom100">
                <div className="container">
                    <div className="d-flex col-md-12 align-items-center justify-content-center flex-column text-center">
                        You do not have enough permissions to access the system.<br />
                        Please contact administrator.
                        <button type="button" className="btn btn-primary mt-4" onClick={(e) => {
                            let url = msalConfigAuthOptions.postLogoutRedirectUri;
                            msalInstance.logoutRedirect(
                                /*{ postLogoutRedirectUri: '/' }*/
                                { postLogoutRedirectUri:  url}
                            );
                            sessionStorage.clear();
                        }} >
                            <AiOutlineHome /> &nbsp; Continue
                        </button>
                    </div>
                </div>
            </div>
        </>)
    }
};
export default UnauthorizedAccess;